/**
 * 同意隐私协议弹窗
 */
import BaseModal from '..';
import Ban from './ban';

const BanModal = {
  self: null,

  show(data = {}) {
    if (this.self) return;
    this.self = BaseModal.show({
      ...data,
      borderRadius: 20,
      closable: false,
      maskClosable: false,
      content: <Ban {...data} onClose={() => this.hide()} />,
    });
  },
  hide() {
    if (this.self) {
      this.self.destroy();
      this.self = null;
    }
  },
};

export default BanModal;
